import { useQueryClient } from '@tanstack/react-query';

import { postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';

import { ELIGIBLE_CARDS_QUERY_KEY } from '@domain/digital-wallet/hooks/query/use-apple-pay-eligible-card-query';
import { PENDING_CARD_TOKEN_QUERY_KEY } from '@domain/digital-wallet/hooks/query/use-pending-cards';

import { useEffectOnAppleWallet } from '../useEffectOnAppleWallet';

const useInvalidateApplePay = () => {
    const queryClient = useQueryClient();

    useEffectOnAppleWallet(() => {
        queryClient.invalidateQueries({ queryKey: ['v4', 'wallet'] });
    });

    return async () => {
        postMessageRN({
            action: WebToRNAction.REFRESH_APPLE_PAY_PROPS,
            payload: undefined,
        });

        await queryClient.invalidateQueries({ queryKey: [PENDING_CARD_TOKEN_QUERY_KEY] });
        await queryClient.invalidateQueries({ queryKey: [ELIGIBLE_CARDS_QUERY_KEY] });
        await queryClient.invalidateQueries({ queryKey: ['v4', 'wallet'] });
    };
};

export default useInvalidateApplePay;
